import React from 'react';
import PropTypes from 'prop-types';
import { Container, GridItem, Text, VStack } from '@chakra-ui/react';
import { Link } from 'gatsby';
import { MdOutlinePictureAsPdf } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import { DeptGrid } from '../../../design-system';

export default function Innotek({ block }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Container>
      {block.headline && (
        <Text color="typography.base" textStyle="h2" as="h2">
          {block.headline}
        </Text>
      )}
      <DeptGrid>
        {block.productGroups?.length ? (
          <>
            {block.productGroups.map(pg => (
              <GridItem colSpan={6} key={pg._key} my="8">
                <Text
                  color="typography.base"
                  textStyle="h4"
                  as="h3"
                  borderBottomColor="typography.base"
                  borderBottomStyle="solid"
                  borderBottomWidth="2px"
                  w="max"
                  mb="4"
                >
                  {pg.headline}
                </Text>
                <Text
                  color="typography.base"
                  textStyle="bodyLarge"
                  fontWeight="bold"
                >
                  {tt(s => s.blocksDeptComponents.manualsLabel)}
                </Text>
                <VStack align="flex-start" gap="4">
                  {pg.downloads?.map(dl => (
                    <Link
                      className="text-foreground bg-muted flex gap-2 py-2 px-4 rounded-lg border border-transparent hover:border-cta"
                      key={dl._key}
                      href={dl.pdf?.asset?.url}
                    >
                      <MdOutlinePictureAsPdf size="24" />
                      {dl.text}
                    </Link>
                  ))}
                </VStack>
              </GridItem>
            ))}
          </>
        ) : null}
      </DeptGrid>
    </Container>
  );
}
Innotek.propTypes = {
  block: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    productGroups: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string.isRequired,
        headline: PropTypes.string.isRequired,
        downloads: PropTypes.arrayOf(
          PropTypes.shape({
            _key: PropTypes.string.isRequired,
            pdf: PropTypes.shape({
              asset: PropTypes.shape({
                url: PropTypes.string.isRequired,
              }).isRequired,
            }).isRequired,
            text: PropTypes.string.isRequired,
          })
        ),
      })
    ),
  }).isRequired,
};
